import React, {useState, useEffect, useRef} from 'react'
import {BrowserRouter as Router, Switch, Route} from 'react-router-dom';
import Home from './pages/Home';
import Employes from './pages/Employes/Employes';
import CreateRole from './pages/Employes/CreateRole';
import AddServicesRoles from './pages/Employes/AddServices';
import AddProductsRoles from './pages/Employes/AddProducts';
import CreateUser from './pages/Employes/CreateUser';
import Navbar from './components/Navbar';
import Sidebar from './components/Sidebar';
import Agenda from './pages/Agenda';
import NewAgenda from './pages/NewAgenda';
import Configuration from './pages/Configuration';
import Services from './pages/Services/Services';
import Specialitys from './pages/Specialitys';
import AllCombos from './pages/Combos/AllCombos';
import UploadCombo from './pages/Combos/UploadCombo';
import DetailCombo from './pages/Combos/DetailCombo';
import Promotions from './pages/Promotions/Promotions';
import UploadPromotion from './pages/Promotions/UploadPromotion';
import Localitys from './pages/Localitys/Localitys';
import AddServices from './pages/Localitys/AddServices';
import Resume from './pages/Resume/Resume';
import Orders from './pages/Orders/Orders';
import Order from './pages/Orders/Order';
import Clients from './pages/Clients/Clients';
import CreateClient from './pages/Clients/CreateClient';
import Client from './pages/Clients/Client';
import History from './pages/Atention/History';
import Sales from './pages/Sales/Sales';
import Messages from './pages/Messages';
import Prueba from './pages/Pruebas';
import Prueba2 from './pages/Pruebas2';
import NewRegister from './pages/NewRegister';
import Claims from './pages/Claims';
import Communities from './pages/Communities/Communities';
import Refereds from './pages/Refereds';
import Plan from './pages/Plan';
import Register from './pages/Register';
import DoctorSignUp from './pages/DoctorSignUp';
import Login from './pages/Login';
import RestartPassword from './pages/RestartPassword';
import firebase from './firebase/config'
import PrivateRoute from './components/PrivateRoute';
import { AuthProvider } from './firebase/auth';
import Profile from './pages/User/Profile';
import PetPoints from './pages/User/PetPoints';
import DataBank from './pages/User/DataBank';
import Products from './pages/Products/Products';
import UploadExcelProducts from './pages/Products/UploadExcelProducts';
import UpdateExcelProducts from './pages/Products/UpdateExcelProducts';
import AgendaServiceCreation from './pages/Services/AgendaServiceCreation';
import AgendaPromoCreation from './pages/Promotions/AgendaPromoCreation';
import PetPointsExchange from './pages/PetPointsExchange/PetPointsExchange';
import Adoption from './pages/Adoption/Adoption';
import Interested from './pages/Adoption/Interested';
import UploadExcelPets from './pages/Adoption/UploadExcelPets';
import Proceedings from './pages/Adoption/Proceedings';
import {Button, Row, Col, Toast} from 'react-bootstrap';
import Content from './pages/Content/Content';
import Compress from "react-image-file-resizer";
import UploadProduct from './pages/Products/UploadProduct';
import NewProducts from './pages/Products/NewProducts';
import DetailProduct from './pages/Products/DetailProduct';
import UploadService from './pages/Services/UploadService';
import NewServices from './pages/Services/NewServices';
import DetailService from './pages/Services/DetailService';
import AllPromotions from './pages/Promotions/AllPromotions';
import DetailPromotion from './pages/Promotions/DetailPromotion';
import Events from './pages/Events/Events';
import DetailEvent from './pages/Events/DetailEvent';
import SettingsPrograms from './Programs/presentation/pages/ProgramsList/ProgramsList';
import Volunteering from './pages/Volunteering/Volunteering';
import Collect from './pages/Collect/Collect';
import DetailCollect from './pages/Collect/DetailCollect';
import DetailVolunteering from './pages/Volunteering/DetailVolunteering';
import Places from './pages/Places/Places';
import DetailPlaces from './pages/Places/DetailPlaces';

function App() {

  const url = window.location.href;
  const user = firebase.isLogged();
  const hiddenFileInput = useRef(null);

  const [allReady, setAllReady] = useState(false);
  const [updateBankState, setUpdateBankState] = useState(false);
  const [activeSidebar, setActiveSidebar] = useState(false);
  const [show, setShow] = useState(false);
  const [notification, setNotification] = useState({title: '', body: ''});
  const [userInfo, setUserInfo] = useState({});
  const [isTokenFound, setTokenFound] = useState(false);
  firebase.getToken(setTokenFound)

  const [file, setFile] = useState(null);
  const [src, setImg] = useState('');
    
  const handleClick = event => {
    hiddenFileInput.current.click();
  };

  async function handleChange(e) {
    var file = e.target.files[0]
    Compress.imageFileResizer(
      file,
      600,
      300,
      "JPEG",
      10,
      0,
      (uri) => {
        setFile(uri)
        console.log(uri)
      },
      "file",
      600,
      300
    )
    setImg(URL.createObjectURL(file))
  }

  firebase.onMessageListener().then(payload => {
    setShow(true);
    setNotification({title: payload.notification.title, body: payload.notification.body})
    console.log(payload);
  }).catch(err => console.log('failed: ', err));
  
  const [firebaseInitialized, setFirebaseInitialized] = useState(false)
  
	useEffect(() => {
    firebase.isInitialized().then(val => {
      setFirebaseInitialized(val);
		})
    user && firebase.getCurrentUser().then((v)=>{
      setUserInfo(v)
    })
	}, [])

  return firebaseInitialized !== false ? (
    <AuthProvider>
      { show && <div className="animated fadeIn toast" role="alert" aria-live="assertive" aria-atomic="true">
        <div className="toast-header row">
          <div className="col-lg-9">
            <img src="/iso.png" className="rounded me-2" alt="..."/>
            <strong className="ml-2 me-auto">{notification.title}</strong>
          </div>
          <div className="col-lg-3">
            <small>Ahora</small>
            <i onClick={() => setShow(false)} className="btn-close ml-2 material-icons cursor-pointer" data-bs-dismiss="toast" aria-label="Close">close</i>
          </div>
        </div>
        <div className="mt-2 toast-body">
          {notification.body}
        </div>
      </div>}
      <Router>
        <div className={ url.includes("/new-register") ? "" : "container-fluid" }>
          <div className={ url.includes("/new-register") ? "" : "row" }>

          {url.includes("/login") || url.includes("/register") || url.includes("/new-register") || !user ? <div></div> : <Sidebar/>}

            <main className={url.includes("/login") || url.includes("/register") || url.includes("/new-register") || !user ? "main-content col-12 px-0" : url.includes("/new-register") ? "" : "main-content col-lg-10 col-md-9 col-sm-12 p-0 offset-lg-2 offset-md-3"}>
              {(url.includes("/login") || url.includes("/register") || url.includes("/new-register")) ? <></> :
              // {(userInfo.cuentaActiva !== undefined && userInfo.cuentaActiva === false && user) &&
              <>
                {/* <div className="modal-starter-register">
                  <p className="modal-starter-register-p">Tu cuenta esta inactiva</p>
                  <div onClick={()=>{ setActiveSidebar(!activeSidebar) }} className="modal-starter-register-btn cursor-pointer">Activar</div>
                </div> */}

                <div className={`sidebar-activation ${activeSidebar && "active"}`}>
                  <div className="sidebar-activation-wrapper">
                    <div className="sidebar-activation-header">
                      <div onClick={()=>{ setActiveSidebar(false) }}  className="sidebar-activation-header-btn cursor-pointer mr-2">
                        <i className="material-icons">close</i>
                      </div>
                      <div className="right-side-info-title">
                        Activar cuenta
                      </div>
                    </div>
                    { allReady ?
                      <div className="sidebar-activation-body fadeIn">
                        <div className="sidebar-activation-body-grid">
                          <p className="sidebar-activation-body-grid-title" >Listo, ¡tu cuenta ya está activa!</p>
                          <span className="material-icons sidebar-activation-body-grid-icon">done</span>
                          <p className="sidebar-activation-body-grid-p" >Eres visible en la app de dueños de mascotas</p>
                          <p className="sidebar-activation-body-grid-p" >Ya puedes configurar tus localidades, permisos, el catalogo de productos, servicios, promociones e ingresar contenido.</p>
                        </div>
                      </div>
                    : <div className="sidebar-activation-body">
                      
                      <div className="mb-2 mt-1">
                        <p className="row-content-container-right-desc">{ !updateBankState ? "Completa los datos necesarios para así activar tu cuenta" : "Completa los datos bancarios para así activar tu cuenta" }</p>
                      </div>

                      { !updateBankState && <div className="mb-2">

                        <input type="file" ref={hiddenFileInput} onChange={handleChange} style={{display: 'none'}}/>
                        <div onClick={handleClick} className="sidebar-activation-body-img-wrapper">
                          { src !== "" ? <img src={src} alt="" /> : <div className="sidebar-activation-body-img"> <p className="material-icons icon mb-1">add</p> <p className="mb-0">Insertar logo</p> </div> }
                        </div>
                      </div> }
                      
                      { updateBankState ? <>
                        <div className="mb-4">
                          <p className="calendar-component-appointment-card-title mb-1">Beneficiario</p>
                          <input type="text" placeholder="Beneficiario" className="form-control" />
                        </div>
                        <div className="mb-4">
                          <p className="calendar-component-appointment-card-title mb-1">Número de cuenta</p>
                          <input type="text" placeholder="Número de cuenta" className="form-control" />
                        </div>
                        <div className="mb-4">
                          <p className="calendar-component-appointment-card-title mb-1">Banco</p>
                          <select className="form-control">
                            <option value="">Banco</option>
                          </select>
                        </div>
                        <div className="mb-4">
                          <p className="calendar-component-appointment-card-title mb-1">Tipo de cuenta</p>
                          <select className="form-control">
                            <option value="">Tipo de cuenta</option>
                          </select>
                        </div>
                        </>
                      : <>
                        <div className="mb-4">
                          <p className="calendar-component-appointment-card-title mb-1">Tipo de persona</p>
                          <select className="form-control">
                            <option value="">Tipo de persona</option>
                          </select>
                        </div>
                        <div className="mb-4">
                          <p className="calendar-component-appointment-card-title mb-1">Nombre de la empresa</p>
                          <input type="text" placeholder="Nombre de la empresa" className="form-control" />
                        </div>
                        <div className="mb-4">
                          <p className="calendar-component-appointment-card-title mb-1">Categoría de aliado</p>
                          <select className="form-control">
                            <option value="">Categoría de aliado</option>
                          </select>
                        </div>
                        <div className="mb-4">
                          <p className="calendar-component-appointment-card-title mb-1">Teléfono</p>
                          <input type="text" placeholder="Nombre de la empresa" className="form-control" />
                        </div>
                      </> }
                      
                    </div> }

                    <div className="sidebar-activation-footer">
                        
                      <div className="btn btn-block btn-primary" onClick={()=>{ 
                        // activateUserInfo() 
                        if(allReady){
                          setUpdateBankState(false)
                          setAllReady(false)
                        }else if(updateBankState){
                          setUpdateBankState(false)
                          setAllReady(true)
                        }else{
                          setUpdateBankState(true)
                        }
                        // updateBankState ? setAllReady(true) : setUpdateBankState(true)
                      }}>Continuar</div>

                    </div>
                  </div>
                </div>

              </>
              }
              {url.includes("/login") || url.includes("/register") || url.includes("/new-register") || !user ? <div></div> : <Navbar/>}
              <Switch>
                <Route path="/login" exact component={Login}/>
                <Route path="/register" exact component={Register}/>
                <Route path="/new-register" exact component={NewRegister}/>
                <Route path="/login/reset-password" exact component={RestartPassword}/>
                <PrivateRoute exact path="/register/doctor_register" component={DoctorSignUp} />
                <PrivateRoute exact path="/" component={Home} />
                <PrivateRoute exact path="/profile" component={Profile} />
                <PrivateRoute exact path="/bank" component={DataBank} />
                <PrivateRoute exact path="/adoption" component={Adoption} />
                <PrivateRoute exact path="/adoption/interested" component={Interested} />
                <PrivateRoute exact path="/adoption/upload-excel" component={UploadExcelPets} />
                <PrivateRoute exact path="/proceedings" component={Proceedings} />
                <PrivateRoute exact path="/pruebas" component={Prueba} />
                <PrivateRoute exact path="/agenda" component={url.includes("localhost") || url.includes("prioritypet-aliados") ? NewAgenda : Agenda} />
                <PrivateRoute path="/agenda2" exact component={Agenda}/>
                {/* <PrivateRoute exact path="/pruebas2" component={Prueba2} /> */}
                <PrivateRoute exact path="/petpoints" component={PetPoints} />
                <PrivateRoute exact path="/employes" component={Employes} />
                <PrivateRoute exact path="/create-user" component={CreateUser} />
                <PrivateRoute exact path="/create-role" component={CreateRole} />
                <PrivateRoute exact path="/create-role/addservices" component={AddServicesRoles} />
                <PrivateRoute exact path="/create-role/addproducts" component={AddProductsRoles} />
                <PrivateRoute path="/client/pet/history" exact component={History}/>
                <PrivateRoute path="/clients/client" exact component={Client}/>
                <PrivateRoute path="/configuration" exact component={Configuration}/>
                <PrivateRoute path="/orders" exact component={Orders}/>
                <PrivateRoute path="/orders/order" exact component={Order}/>
                <PrivateRoute path="/clients" exact component={Clients}/>
                <PrivateRoute path="/sales" exact component={Sales}/>
                <PrivateRoute path="/communities" exact component={Communities}/>

                <PrivateRoute path="/configuration/events" exact component={Events}/>
                <PrivateRoute path="/configuration/events/detail" exact component={DetailEvent}/>
                <PrivateRoute path="/configuration/content" exact component={Content}/>
                <PrivateRoute path="/configuration/services" exact component={NewServices}/>
                {/* <PrivateRoute path="/configuration/services" exact component={Services}/> */}
                <PrivateRoute path="/configuration/services/new-service" exact component={UploadService}/>
                <PrivateRoute path="/configuration/services/new-services" exact component={NewServices}/>
                <PrivateRoute path="/configuration/services/detail" exact component={DetailService}/>
                <PrivateRoute path="/configuration/services/agenda" exact component={AgendaServiceCreation}/>
                <PrivateRoute path="/promotions/agenda" exact component={AgendaPromoCreation}/>
                <PrivateRoute path="/configuration/localitys" exact component={Localitys}/>
                <PrivateRoute path="/configuration/localitys/addservices" exact component={AddServices}/>
                <PrivateRoute path="/configuration/products" exact component={NewProducts}/>
                {/* <PrivateRoute path="/configuration/products" exact component={Products}/> */}
                <PrivateRoute path="/configuration/products/detail" exact component={DetailProduct}/>
                <PrivateRoute path="/configuration/products/new-product" exact component={UploadProduct}/>
                <PrivateRoute path="/configuration/products/new-products" exact component={NewProducts}/>
                <PrivateRoute path="/configuration/products/upload-excel" exact component={UploadExcelProducts}/>
                <PrivateRoute path="/configuration/products/update-excel" exact component={UpdateExcelProducts}/>
                <PrivateRoute path="/configuration/exchange" exact component={PetPointsExchange}/>
                <PrivateRoute path="/configuration/specialitys" exact component={Specialitys}/>
                <PrivateRoute path="/configuration/programs" exact component={SettingsPrograms}/>
                <PrivateRoute path="/configuration/volunteering" exact component={Volunteering}/>
                <PrivateRoute path="/configuration/volunteering/detail" exact component={DetailVolunteering}/>
                <PrivateRoute path="/configuration/collect" exact component={Collect}/>
                <PrivateRoute path="/configuration/collect/detail" exact component={DetailCollect}/>
                <PrivateRoute path="/configuration/place" exact component={Places}/>
                <PrivateRoute path="/configuration/place/detail" exact component={DetailPlaces}/>

                <PrivateRoute path="/clients" exact component={Clients}/>
                <PrivateRoute path="/clients/create-client" exact component={CreateClient}/>
                <PrivateRoute path="/resume" exact component={Resume}/>
                <PrivateRoute path="/combos" exact component={AllCombos}/>
                <PrivateRoute path="/combos/new-combo" exact component={UploadCombo}/>
                <PrivateRoute path="/combos/detail" exact component={DetailCombo}/>
                {/* <PrivateRoute path="/promotions" exact component={Promotions}/> */}
                <PrivateRoute path="/promotions" exact component={AllPromotions}/>
                <PrivateRoute path="/promotions/new-promotion" exact component={UploadPromotion}/>
                <PrivateRoute path="/promotions/detail" exact component={DetailPromotion}/>
                <PrivateRoute path="/messages" exact component={Messages}/>
                <PrivateRoute path="/claims" exact component={Claims}/>
                <PrivateRoute path="/refereds" exact component={Refereds}/>

                <PrivateRoute path="/plans" exact component={Plan}/>
                <Route path='*' component={Page404} />
              </Switch>
            </main>
          </div>
        </div>
      </Router>
    </AuthProvider>
  ) : <div className="p404">Cargando</div>

  async function activateUserInfo(){
    try{
      await firebase.db.collection("Aliados").doc(userInfo.aliadoId).update({
        cuentaActiva: true
      })
    }catch(e){
      console.log("Error: " + e)
    }
  }

}

const Page404 = () => (
  <div className="p404">
      <h1><b>No existe esa página</b></h1>
      <p className="lead">Parece que la página que estás tratando de buscar no existe.</p>
      <a href="/">Volver al Inicio</a>
  </div>
)

export default App;